"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROMPT_LAB = exports.DOWNLOAD_BATCH = exports.HIGH_YIELD = void 0;
const client_1 = require("@apollo/client");
exports.HIGH_YIELD = (0, client_1.gql) `
  mutation HighYield($chapterIds: [Int!]!, $settings: AISettingsInput!) {
    admin {
      highYield(chapterIds: $chapterIds, settings: $settings)
    }
  }
`;
exports.DOWNLOAD_BATCH = (0, client_1.gql) `
  mutation downloadBatch($batchId: String!, $apiKey: String!) {
    admin {
      downloadBatch(batchId: $batchId, apiKey: $apiKey)
    }
  }
`;
exports.PROMPT_LAB = (0, client_1.gql) `
  mutation promptLab($input: AISettingsInput!) {
    admin {
      promptLab(input: $input) {
        index
        finishReason
        message {
          role
          content
          refusal
        }
      }
    }
  }
`;
